<div class="toolbar">
  <div class="col-md-8">
    <h1>{{title}}</h1>
  </div>
</div>